import HttpService from "./http-service";
import AsyncPaginatedRequest from "./async-paginated-request";
import {LazyAsyncIter} from "@/iterators";
import {pageMapperBuilder, Paginated} from "@/pagination";
import BudgetExecutionAccount, {AccountGroup} from "@/entities/budget-execution-account";

export default class BudgetExecutionAccountService extends HttpService {
    public getAllBudgetExecutionAccounts(
        params: SearchBudgetExecutionAccountRequestParams
    ): AsyncIterator<Paginated<BudgetExecutionAccount>> {
        const asyncReq = new AsyncPaginatedRequest<BudgetExecutionAccountDTO>(
            "get",
            "budget-execution-accounts",
            params,
            undefined,
            this.httpClient
        )[Symbol.asyncIterator]();
        return new LazyAsyncIter(asyncReq).map(pageMapperBuilder(budgetExecutionAccountFromDTO));
    }

    public async getAllBudgetExecutionAccountGroups(): Promise<Array<BudgetExecutionAccountGroup>> {
        const {data} = await this.httpClient.get(`groups/budget-execution-account}`);
        return data;
    }

    public async createBudgetExecutionAccount(accountDetails: BudgetExecutionAccount): Promise<void> {
        const query = {
            cta: accountDetails.cta,
            description: accountDetails.description,
            group_id: accountDetails.group_id
        }
        return this.httpClient.post("budget-execution-accounts/", query);
    }

    public async getAccountDetails(BudgetExecutionAccountId: number): Promise<BudgetExecutionAccount> {
        const {data} = await this.httpClient.get(`budget-execution-accounts/${BudgetExecutionAccountId}/details`);
        return data;
    }

    public async updateBudgetExecutionAccount(accountDetails: BudgetExecutionAccount,BudgetExecutionAccountId: number):Promise<void>{
        const query = {
            cta: accountDetails.cta,
            description: accountDetails.description,
            group_id: accountDetails.group_id
        }
        return this.httpClient.put(`budget-execution-accounts/${BudgetExecutionAccountId}`, query);
    }
}

export interface SearchBudgetExecutionAccountRequestParams {
    title?: string;
    status?: string;
}

export interface BudgetExecutionAccountDTO {
    id: number;
    cta: number;
    description: string;
    group_id: number;
    account_group: AccountGroup;
    created_at: string
}

export function budgetExecutionAccountFromDTO
(dto: BudgetExecutionAccountDTO): BudgetExecutionAccount {
    return new BudgetExecutionAccount({
        id: dto.id,
        cta: dto.cta,
        description: dto.description,
        group_id: dto.group_id,
        account_group: dto.account_group,
        created_at: dto.created_at
    });
}


export interface BudgetExecutionAccountGroup {
    id: number,
    name: string
}